import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMedia } from "react-use";
import {
  ExclamationCircleFilled,
  MessageOutlined,
  // SearchOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Modal, Space, Tooltip, Typography } from "antd";
import {
  BoxIcon,
  // FolderIcon,
  LayoutRightIcon,
  LockRedIcon,
  // SearchIcon,
} from "assets/icons";
// import _ from "lodash";
import { AuthInfo } from "stores/slices/auth";
import {
  doDeleteConversation,
  doGetConversationEvent,
  doUpdateConversation,
  getConversationSelected,
  isLockCurrentConversation,
  selectIsLockNotCurrentSessionConversation,
  selectIsLockUserIdConversation,
} from "stores/slices/conversation";
import { getUserList } from "stores/slices/user";
// import { getUserDetail } from "stores/slices/user";

const { confirm } = Modal;

const ChatMessageHeader = props => {
  const {
    below768,
    isOpenLayoutRight,
    setIsOpenLayoutRight,
    // inputUploadFileRef,
    // params,
    // setParams,
    // serviceNumber,
    serviceSelected,
  } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const over1024 = useMedia("(max-width: 1024px)");

  const authInfo = useSelector(AuthInfo);
  const conversationSelected = useSelector(getConversationSelected);
  const userList = useSelector(getUserList);
  const [userLocked, setUserLocker] = useState("");
  const isCurrentLockConversation = useSelector(isLockCurrentConversation);

  const isLockNotCurrentSessionConversation = useSelector(
    selectIsLockNotCurrentSessionConversation
  );
  const isLockUserIdConversation = useSelector(selectIsLockUserIdConversation);

  const doListenConversationEv = async () => {
    if (authInfo && authInfo.workspaceId) {
      await dispatch(
        doGetConversationEvent({ workspaceId: authInfo.workspaceId })
      );
    }
  };

  const handleArchive = data => {
    confirm({
      title:
        data?.status === "DELETE"
          ? t("inbox.chatList.unarchive")
          : t("inbox.chatList.archive"),
      icon: <ExclamationCircleFilled />,
      content:
        data?.status === "DELETE"
          ? t("inbox.chatList.unarchiveMsg")
          : t("inbox.chatList.archiveMsg"),
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        if (data?.status === "DELETE") {
          const request = {
            id: data.id,
            status: "ACTIVE",
          };
          await dispatch(doUpdateConversation(request));
        } else {
          const request = {
            id: data.id,
          };
          const { payload } = await dispatch(doDeleteConversation(request));
          if (payload && payload.status === 200) {
            await doListenConversationEv();
            navigate("/inbox/messages");
          }
        }
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    if (userList && userList.length > 0) {
      const user = userList.find(
        item => item.id === conversationSelected?.lockUserId
      );
      if (user) {
        setUserLocker(` ${user.firstName} ${user.lastName}` || `${user.email}`);
      }
    }
  }, [conversationSelected?.lockUserId]);

  return (
    <div style={{ padding: "20px", borderBottom: "1px solid #DEE1E5" }}>
      <div className="chatMessageHeader">
        <div>
          <Space align="center">
            {conversationSelected &&
              conversationSelected.profileImage !== null &&
              conversationSelected.profileImage !== "" &&
              (!conversationSelected.broadcastScheduleId ||
                conversationSelected.broadcastScheduleId === null) && (
                <Avatar size={50} src={conversationSelected.profileImage} />
              )}
            {conversationSelected &&
              (conversationSelected.profileImage === null ||
                conversationSelected.profileImage === "") &&
              (!conversationSelected.broadcastScheduleId ||
                conversationSelected.broadcastScheduleId === null) && (
                <Avatar size={50} icon={<UserOutlined />} />
              )}
            {conversationSelected &&
              conversationSelected.broadcastScheduleId &&
              conversationSelected.broadcastScheduleId !== null && (
                <Avatar size={50} icon={<MessageOutlined />} />
              )}

            <div
              style={{
                maxWidth: over1024 ? "150px" : "220px",
              }}
            >
              {conversationSelected?.firstName ||
              conversationSelected?.lastName ? (
                <>
                  <Tooltip
                    title={`${
                      conversationSelected?.firstName !== undefined &&
                      conversationSelected?.firstName !== null
                        ? conversationSelected?.firstName
                        : ""
                    } ${
                      conversationSelected?.lastName !== undefined &&
                      conversationSelected?.lastName !== null
                        ? conversationSelected?.lastName
                        : ""
                    }  (${conversationSelected?.phoneNumber})`}
                  >
                    <Typography.Title
                      level={5}
                      style={{
                        marginBottom: 0,

                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {`${
                        conversationSelected?.firstName !== undefined &&
                        conversationSelected?.firstName !== null
                          ? conversationSelected?.firstName
                          : ""
                      } ${
                        conversationSelected?.lastName !== undefined &&
                        conversationSelected?.lastName !== null
                          ? conversationSelected?.lastName
                          : ""
                      } `}
                    </Typography.Title>
                    <Typography.Title
                      level={5}
                      style={{
                        marginBottom: 0,
                        marginTop: 0,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {`(${conversationSelected?.phoneNumber})`}
                    </Typography.Title>
                  </Tooltip>
                </>
              ) : (
                <>
                  <Tooltip title={`${conversationSelected?.phoneNumber}`}>
                    <Typography.Title
                      level={5}
                      style={{
                        marginBottom: 0,
                        marginTop: 0,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {`${conversationSelected?.phoneNumber}`}
                    </Typography.Title>
                  </Tooltip>
                </>
              )}
            </div>
            <div> - </div>
            <div
              style={{
                maxWidth: over1024 ? "150px" : "220px",
              }}
            >
              <Tooltip
                title={`${authInfo?.workspaceName} ${
                  serviceSelected?.service !== "" &&
                  serviceSelected?.service !== undefined
                    ? `(${serviceSelected?.service})`
                    : ""
                }`}
              >
                <Typography.Title
                  level={5}
                  style={{
                    marginBottom: 0,
                    // maxWidth: over1024 ? "12em" : "27em",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {`${authInfo?.workspaceName}`}
                </Typography.Title>
                <Typography.Title
                  level={5}
                  style={{
                    marginBottom: 0,
                    marginTop: 0,
                    // maxWidth: over1024 ? "12em" : "27em",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {` ${
                    serviceSelected?.service !== "" &&
                    serviceSelected?.service !== undefined
                      ? `(${serviceSelected?.service})`
                      : ""
                  }`}
                </Typography.Title>
              </Tooltip>
            </div>

            {isCurrentLockConversation && (
              <>
                <Tooltip title={`Conversation locked by you`}>
                  <div
                    style={{
                      borderRadius: "50%",
                      width: 35,
                      height: 35,
                      backgroundColor: "#FDF1F3",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LockRedIcon color={"#0E9154"} />
                  </div>
                </Tooltip>
              </>
            )}
            {isLockNotCurrentSessionConversation &&
              !isCurrentLockConversation && (
                <Tooltip
                  title={
                    isLockUserIdConversation
                      ? `Conversation locked by you`
                      : `Conversation locked by ${userLocked}`
                  }
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      width: 35,
                      height: 35,
                      backgroundColor: "#FDF1F3",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LockRedIcon
                      color={isLockUserIdConversation ? "#0E9154" : "#A9122B"}
                    />
                  </div>
                </Tooltip>
              )}
          </Space>
        </div>
        {below768 && (
          <div>
            <Space size={"small"}>
              {/* <Tooltip title="Search">
                <Button
                  icon={<SearchIcon />}
                  onClick={() => setIsSearch(!isSearch)}
                  // disabled={conversationSelected?.lockUserId !== authInfo?.id}
                  disabled={
                    conversationSelected?.lock &&
                    conversationSelected?.lockUserId !== authInfo?.id
                  }
                />
              </Tooltip> */}
              {/* <Tooltip title="Show media">
                <Button
                  icon={<FolderIcon />}
                  onClick={handleUploadFile}
                  // disabled={
                  //   conversationSelected?.spam ||
                  //   conversationSelected?.blockUser ||
                  //   conversationSelected?.status === "DELETE" ||
                  //   conversationSelected?.lockUserId !== authInfo?.id
                  // }
                  disabled={
                    (conversationSelected?.lock &&
                      conversationSelected?.lockUserId !== authInfo?.id) ||
                    conversationSelected?.blockUser ||
                    conversationSelected?.status === "DELETE"
                  }
                />
              </Tooltip> */}
              <Tooltip
                title={
                  conversationSelected?.status === "DELETE"
                    ? t("inbox.chatList.unarchive")
                    : t("inbox.chatList.archive")
                }
              >
                <Button
                  icon={<BoxIcon />}
                  onClick={() => handleArchive(conversationSelected)}
                  disabled={isLockNotCurrentSessionConversation}
                />
              </Tooltip>
              <Tooltip title="Customer information">
                <Button
                  icon={<LayoutRightIcon />}
                  onClick={() => {
                    setIsOpenLayoutRight(!isOpenLayoutRight);
                  }}
                  disabled={
                    (conversationSelected.totalBroadcastCustomer &&
                      (conversationSelected.totalBroadcastCustomer !==
                        undefined ||
                        conversationSelected.totalBroadcastCustomer !==
                          null)) ||
                    isLockNotCurrentSessionConversation
                  }
                  className="chatMessageHeaderButton"
                />
              </Tooltip>
            </Space>
          </div>
        )}
      </div>
      {/* {isSearch && (
        <div style={{ marginTop: 12 }}>
          <Input
            placeholder="Search"
            prefix={<SearchOutlined />}
            onChange={handleSearch}
          />
        </div>
      )} */}
    </div>
  );
};

export default ChatMessageHeader;
